import { render, staticRenderFns } from "./quick-review.vue?vue&type=template&id=6b1590bc&"
import script from "./quick-review.vue?vue&type=script&lang=ts&"
export * from "./quick-review.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports